import SyncIcon from "@mui/icons-material/Sync";
import { Box } from "@mui/material";
import { GridPaginationModel } from "@mui/x-data-grid";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useParams } from "react-router-dom";
import useSelectedPatient from "@/hooks/local-storage/use-selected-patient";
import { useSnackbar } from "@/hooks/useSnackbar";
import { useSyncScriptsurePatient } from "@/queries/script-sure/use-sync-scriptsure-patient";
import { ChartActionStrip } from "../../../../../../../../components/app/provider/patient/chart";
import useDisclosure from "../../../../../../../../hooks/use-disclosure";
// import { useSnackbar } from "../../../../../../../../hooks/useSnackbar";
import { useGetOrderPrescription } from "../../../../../../../../queries/patient-chart/order/prescription/get-all-prescription";
// import { usePrescriptionStatusChange } from "../../../../../../../../queries/patient-chart/order/prescription/use-prescription-status-change";
// import { UpdatePrescriptionStatusStatusEnum } from "../../../../../../../../services";
import {
  DEF_PAGINATION,
  getXtenantId,
  showToastOnApiCall,
} from "../../../../../../../../utils/utils";
import UpsertPrescriptionForm from "../../../../../scheduling/appointment/encounter/prescription/UpsertPrescriptionForm";
import EPrescriptions from "./EPrescriptions";
import { PrescriptionsPopUp } from "./PrescriptionsPopUp";
import PrescriptionTable from "./PrescriptionTable";
import PrintPrescription from "./PrintPrescription";
const OrderPrescription = () => {
  const { patientId } = useParams();
  const queryClient = useQueryClient();
  const showSnackbar = useSnackbar();
  const [showeprescription, setShoweprescription] = useState(false);

  const [paginationModel, setPaginationModel] =
    useState<GridPaginationModel>(DEF_PAGINATION);

  const { data: allPrescription } = useGetOrderPrescription({
    pagination: {
      page: paginationModel.page,
      pageSize: paginationModel.pageSize,
    },
    patientUuid: patientId as string,
    archive: false,
    xTENANTID: getXtenantId(),
  });

  const prescriptionDisc = useDisclosure();
  const [printPrescriptionId, setPrintPrescriptionId] = useState<string>();

  // const { mutateAsync: prescriptionStatusChange } =
  //   usePrescriptionStatusChange();

  const isVisitNotePage = window.location.pathname.includes("/visit-note");

  /**
   * Patients created before the ScriptSure integration was enabled are not
   * registered there, so they must be synced before e-prescribing.
   */
  const [selectedPatient] = useSelectedPatient();
  const isScriptSureSynced = !!selectedPatient?.isScriptSure;

  const { mutateAsync: syncScriptsurePatient, isPending: isSyncingPatient } =
    useSyncScriptsurePatient();

  const handleSyncPatientToScriptSure = () => {
    showToastOnApiCall({
      apiCall: syncScriptsurePatient({
        patientId: patientId as string,
        xTENANTID: getXtenantId() ?? "",
      }),
      showSnackbar,
      onSave: () => {
        queryClient.invalidateQueries({ queryKey: ["patient", patientId] });
      },
    });
  };

  const handleViewPrescription = (row: any) => {
    // Skip the Rx preview sidesheet and open the print modal directly
    setPrintPrescriptionId(row?.uuid);
  };

  // Handlers below fed the Rx preview sidesheet (now skipped). Prescription
  // status change / cancel are handled inside PrescriptionTable. Kept for reference.
  // const handleViewPrint = (prescriptionId: string) => {
  //   setPrintPrescriptionId(prescriptionId);
  // };

  // const handleStatusChange = (
  //   prescriptionId: string,
  //   status: string,
  //   reason?: string
  // ) => {
  //   showToastOnApiCall({
  //     showSnackbar,
  //     apiCall: prescriptionStatusChange({
  //       prescriptionFormId: prescriptionId,
  //       status: status as UpdatePrescriptionStatusStatusEnum,
  //       reason,
  //     }),
  //     onSave: () => {
  //       queryClient.invalidateQueries({
  //         queryKey: ["patient-prescription-list"],
  //       });
  //     },
  //   });
  // };

  // const handleCancel = (prescriptionId: string, reason: string) => {
  //   handleStatusChange(prescriptionId, "CANCELED", reason);
  // };

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <UpsertPrescriptionForm disclosureHost={prescriptionDisc} />
      {printPrescriptionId && (
        <PrintPrescription
          prescriptionFormId={printPrescriptionId}
          onClose={() => setPrintPrescriptionId(undefined)}
        />
      )}
      {!isVisitNotePage && (
        <ChartActionStrip
          endContent={
            <>
              {!isScriptSureSynced && (
                <ChartActionStrip.Button
                  variant="outlined"
                  startIcon={<SyncIcon />}
                  onClick={handleSyncPatientToScriptSure}
                  disabled={isSyncingPatient}
                >
                  Sync with ScriptSure
                </ChartActionStrip.Button>
              )}
              <PrescriptionsPopUp
                onOptionClick={(v) => {
                  if (v === "paper_prescription") {
                    prescriptionDisc.open();
                  } else if (v === "eletronic_prescription") {
                    setShoweprescription(true);
                  }
                }}
              />
            </>
          }
        />
      )}
      <Box sx={{ flex: 1, overflow: "hidden" }}>
        {showeprescription && <EPrescriptions />}
        {!showeprescription && (
          <PrescriptionTable
            data={{
              content: allPrescription?.data?.content || [],
              page: allPrescription?.data?.page as any,
            }}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            onViewPrescription={handleViewPrescription}
          />
        )}
      </Box>
    </Box>
  );
};

export default OrderPrescription;
